import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}) {
  return <AnimatePresence data-id="element-169">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.25
    }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-charcoal/70 backdrop-blur-sm" onClick={onClose} data-id="element-170">
          <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.97
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.97
      }} transition={{
        duration: 0.3
      }} className="bg-warm-white rounded-xl shadow-2xl max-w-2xl w-full max-h-[85vh] overflow-y-auto" onClick={e => e.stopPropagation()} data-id="element-171">
            <div className="sticky top-0 bg-warm-white border-b border-border-gray px-6 py-4 flex items-center justify-between rounded-t-xl z-10" data-id="element-172">
              <h2 className="text-xl font-bold text-charcoal font-serif" data-id="element-173">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-warm-gray transition-colors text-charcoal/60 hover:text-charcoal" data-id="element-174">
                <X className="w-5 h-5" data-id="element-175" />
              </button>
            </div>
            <div className="px-6 py-6 text-charcoal/80 text-base leading-relaxed space-y-4" data-id="element-176">
              {children}
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}
export function SalesFooter() {
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="w-full bg-charcoal text-warm-white/60 py-12 px-6" data-id="element-177">
        <div className="max-w-reading mx-auto text-center space-y-6" data-id="element-178">
          <p className="text-sm leading-relaxed" data-id="element-179">
            Disclaimer: This product is educational and does not constitute
            medical advice. Consult your healthcare provider for medical
            concerns.
          </p>

          <div className="h-px bg-white/10 w-24 mx-auto my-6" data-id="element-180"></div>

          <p className="text-sm" data-id="element-181">
            &copy; {new Date().getFullYear()} The Quiet Bladder Reset. All
            rights reserved.
          </p>

          <div className="flex justify-center gap-6 text-sm" data-id="element-182">
            <span onClick={() => setShowPrivacy(true)} className="hover:text-white cursor-pointer transition-colors underline underline-offset-2" data-id="element-183">
              Privacy Policy
            </span>
            <span onClick={() => setShowTerms(true)} className="hover:text-white cursor-pointer transition-colors underline underline-offset-2" data-id="element-184">
              Terms &amp; Conditions
            </span>
          </div>
        </div>
      </footer>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={showPrivacy} onClose={() => setShowPrivacy(false)} title="Privacy Policy" data-id="element-185">
        <p className="text-sm text-charcoal/50 italic" data-id="element-186">
          Last updated:{' '}
          {new Date().toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })}
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg mt-4" data-id="element-187">
          1. Information We Collect
        </h3>
        <p data-id="element-188">
          When you purchase The Quiet Bladder Reset, we collect only the
          information necessary to process your order: your name, email address,
          and payment details. Payment information is processed securely through
          our third-party payment processor and is never stored on our servers.
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-189">
          2. How We Use Your Information
        </h3>
        <p data-id="element-190">We use your information to:</p>
        <ul className="list-disc pl-6 space-y-1" data-id="element-191">
          <li data-id="element-192">Deliver your digital product and any updates</li>
          <li data-id="element-193">Send transactional emails related to your purchase</li>
          <li data-id="element-194">
            Send follow-up educational emails (you can unsubscribe at any time)
          </li>
          <li data-id="element-195">Improve our products and customer experience</li>
        </ul>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-196">
          3. Information Sharing
        </h3>
        <p data-id="element-197">
          We do not sell, trade, or rent your personal information to third
          parties. We may share information only with trusted service providers
          who assist in operating our business (payment processing, email
          delivery), and only to the extent necessary to provide our services.
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-198">
          4. Data Security
        </h3>
        <p data-id="element-199">
          We implement reasonable security measures to protect your personal
          information. However, no method of electronic transmission or storage
          is 100% secure, and we cannot guarantee absolute security.
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-200">
          5. Cookies
        </h3>
        <p data-id="element-201">
          Our website may use cookies and similar tracking technologies to
          improve your browsing experience and analyze site traffic. You can
          control cookie settings through your browser preferences.
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-202">
          6. Your Rights
        </h3>
        <p data-id="element-203">
          You have the right to access, correct, or delete your personal data.
          To exercise these rights, contact us at the email provided below. We
          will respond to your request within 30 days.
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-204">
          7. Changes to This Policy
        </h3>
        <p data-id="element-205">
          We may update this Privacy Policy from time to time. Any changes will
          be posted on this page with an updated revision date.
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-206">
          8. Contact
        </h3>
        <p data-id="element-207">
          If you have questions about this Privacy Policy, please contact us at:{' '}
          <span className="font-medium text-charcoal" data-id="element-208">
            support@quietbladderreset.com
          </span>
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={showTerms} onClose={() => setShowTerms(false)} title="Terms & Conditions" data-id="element-209">
        <p className="text-sm text-charcoal/50 italic" data-id="element-210">
          Last updated:{' '}
          {new Date().toLocaleDateString('en-US', {
          month: 'long',
          day: 'numeric',
          year: 'numeric'
        })}
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg mt-4" data-id="element-211">
          1. Product Description
        </h3>
        <p data-id="element-212">
          The Quiet Bladder Reset is a digital educational product delivered as
          a downloadable PDF guide with accompanying printable materials. This
          product is designed to provide general health education and is not a
          substitute for professional medical advice, diagnosis, or treatment.
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-213">
          2. Medical Disclaimer
        </h3>
        <p data-id="element-214">
          The information provided in The Quiet Bladder Reset is for educational
          purposes only. It is not intended to diagnose, treat, cure, or prevent
          any disease or medical condition. Always consult with a qualified
          healthcare provider before making changes to your health routine,
          especially if you have existing medical conditions or are taking
          medications.
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-215">
          3. Purchase & Delivery
        </h3>
        <p data-id="element-216">
          Upon successful payment, you will receive immediate access to download
          the digital product. Delivery is electronic — no physical product will
          be shipped. You are responsible for downloading and saving your files.
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-217">
          4. Refund Policy
        </h3>
        <p data-id="element-218">
          Due to the digital nature of this product, all sales are final. If you
          experience technical issues accessing your download, please contact us
          and we will resolve the issue promptly.
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-219">
          5. Intellectual Property
        </h3>
        <p data-id="element-220">
          All content within The Quiet Bladder Reset is protected by copyright.
          You may not reproduce, distribute, modify, or create derivative works
          from this material without express written permission. Your purchase
          grants you a personal, non-transferable license to use the materials
          for your own benefit.
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-221">
          6. No Guarantees
        </h3>
        <p data-id="element-222">
          While The Quiet Bladder Reset is based on established health
          principles, individual results may vary. We make no guarantees
          regarding specific outcomes. Your results depend on many factors
          including your individual health situation, consistency of
          application, and other variables beyond our control.
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-223">
          7. Limitation of Liability
        </h3>
        <p data-id="element-224">
          To the maximum extent permitted by law, The Quiet Bladder Reset and
          its creators shall not be liable for any indirect, incidental,
          special, or consequential damages arising from your use of this
          product.
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-225">
          8. Governing Law
        </h3>
        <p data-id="element-226">
          These terms shall be governed by and construed in accordance with
          applicable laws. Any disputes shall be resolved through good-faith
          negotiation before pursuing other remedies.
        </p>

        <h3 className="font-bold text-charcoal font-serif text-lg" data-id="element-227">
          9. Contact
        </h3>
        <p data-id="element-228">
          For questions about these Terms & Conditions, please contact us at:{' '}
          <span className="font-medium text-charcoal" data-id="element-229">
            support@quietbladderreset.com
          </span>
        </p>
      </LegalModal>
    </>;
}